import { AsyncPipe, NgTemplateOutlet } from '@angular/common';
import {
  AfterViewInit,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ComponentFactory,
  ComponentFactoryResolver,
  ComponentRef,
  EventEmitter,
  inject,
  Input,
  Output,
  TemplateRef,
  ViewChild,
  ViewContainerRef,
} from '@angular/core';

import { NgbToastModule } from '@ng-bootstrap/ng-bootstrap';

import { KROS_DESIGN_VERSION, NEW_DESIGN } from '@kros-sk/core/design-version';

import { ToastService } from '../../services/toast.service';

interface ProgressData {
  current: number;
}

const V4_DESIGN = 4;

@Component({
  selector: 'kros-toast',
  templateUrl: './toast.component.html',
  styleUrls: ['./toast.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [AsyncPipe, NgTemplateOutlet, NgbToastModule],
})
export class ToastComponent implements AfterViewInit {
  @Input() toast: any;
  @Output() remove: EventEmitter<any> = new EventEmitter();
  @ViewChild('toastContainer', { read: ViewContainerRef }) container!: ViewContainerRef;

  protected newDesign = inject(NEW_DESIGN, { optional: true });
  protected isV4Design = (inject(KROS_DESIGN_VERSION, { optional: true }) ?? 0) >= V4_DESIGN;

  isTemplate(toast: any): boolean {
    return toast.textOrTpl instanceof TemplateRef;
  }
  isComponent(toast: any): boolean {
    return typeof toast.textOrTpl !== 'string' && !this.isTemplate(toast);
  }

  constructor(
    public toastService: ToastService,
    private resolver: ComponentFactoryResolver,
    private cdRef: ChangeDetectorRef
  ) {}

  ngAfterViewInit(): void {
    if (this.isComponent(this.toast)) {
      const factory: ComponentFactory<any> = this.resolver.resolveComponentFactory(this.toast.textOrTpl);
      const component: ComponentRef<any> = this.container.createComponent(factory);
      component.instance.toast = this.toast;
      this.cdRef.detectChanges();
    }
  }

  getToastIcon(toast: any): string {
    switch (true) {
      case /kros-info/.test(toast.classname):
        return 'info';
      case /kros-warning/.test(toast.classname):
        return 'warning';
      default:
        return 'error';
    }
  }

  getToastIconNewDesign(toast: any): string {
    switch (true) {
      case /kros-info/.test(toast.classname):
        return 'hgi-information-square';
      case /kros-warning/.test(toast.classname):
        return 'hgi-alert-02';
      default:
        return 'hgi-alert-square';
    }
  }

  isWarningToast(toast: any): boolean {
    return /kros-warning/.test(toast.classname);
  }

  getProgressCurrent(progress: any): number {
    return (progress as ProgressData)?.current || 0;
  }
}
